import React, { Component } from "react";

export class PaginaPlataformas extends Component {
  render() {
    return <h1>Vengo de la pagina Plataformas</h1>;
  }
}
